import './Modal.css'
import Modal from 'react-bootstrap/Modal'
import { Spinner } from 'react-bootstrap'
import React, { useState } from 'react'
import SubArtefactPicker from './SubArtefactPicker'
import { authHeader } from '../../../helpers/auth-header'
import axios from 'axios'
import constants from '../../../constants'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

export default function AddClassModal({ userStory, show, onHide }) {
    const queryClient = useQueryClient()
    const [loading, setLoading] = useState(false)
    const [pickedSubArtefacts, setPickedSubArtefacts] = useState([])
    const [className, setClassName] = useState('')
    const [isActor, setIsActor] = useState(false)
    const { projectId } = useParams()

    async function onSave() {
        const requestConfig = {
            headers: authHeader(),
        }
        const body = {
            name: className,
            mainArtefactId: userStory.usId,
            position: pickedSubArtefacts.map(psa => psa.index),
            type: isActor ? 'ACTOR' : 'CLASS',
        }
        setLoading(true)
        await axios.post(`${ constants().apiUrl }/project/${ projectId }/conceptual-model/main-entity`, body, requestConfig)
        await queryClient.invalidateQueries({ queryKey: [`tracing-data-${ projectId }`] })
        setLoading(false)
        onHide()
    }

    return (
        <Modal
            show={ show }
            onHide={ onHide }
            size={ 'lg' }
            aria-labelledby={ 'contained-modal-title-vcenter' }
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id={ 'contained-modal-title-vcenter' }>
                    Add Class
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body">
                { loading ?
                    <div className="loading-container">
                        <Spinner animation="grow"/>
                    </div> :
                    <>
                        <div className="modal-input-group">
                            <label htmlFor="class-name">Class name:</label>
                            <input
                                type="text"
                                name="class-name"
                                value={ className }
                                onChange={ (e) => setClassName(e.target.value) }
                            />
                        </div>
                        <div className='modal-input-group-row'>
                            <label htmlFor="is-actor">Is actor</label>
                            <input type="checkbox" checked={ isActor } onChange={ e => setIsActor(e.target.checked) }/>
                        </div>
                        <SubArtefactPicker
                            subArtefacts={ userStory.subArtefacts }
                            pickedSubArtefacts={ pickedSubArtefacts }
                            setPickedSubArtefacts={ setPickedSubArtefacts }
                        />
                        <div className="modal-button-row">
                            <button onClick={ onHide }>Cancel</button>
                            <button onClick={ onSave }>Save</button>
                        </div>
                    </>
                }
            </Modal.Body>
        </Modal>
    )
}